import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=a5fbaaf6&"
import script from "./Projects.vue?vue&type=script&lang=js&"
export * from "./Projects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5fbaaf6')) {
      api.createRecord('a5fbaaf6', component.options)
    } else {
      api.reload('a5fbaaf6', component.options)
    }
    module.hot.accept("./Projects.vue?vue&type=template&id=a5fbaaf6&", function () {
      api.rerender('a5fbaaf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/Profile/Projects.vue"
export default component.exports